import { en } from './en';

type TFunction = (translation: (locales: typeof en) => string) => string;

export const useTranslation = (): [TFunction] => [(translation) => translation(en)];
